<template>
  <motlet-neo :options="motletOptions">
    <template v-slot:content="{ props }">
      <!-- eslint-disable-next-line prettier/prettier -->
      <line-chart
        :settings="settings"
        :motlet="props.motlet"
        :store-name="storeName"
        :active-increment="activeIncrement"
      />
    </template>
  </motlet-neo>
</template>

<script>
// import { merge, isEmpty } from 'lodash';
import { merge } from 'lodash';
// BEGIN::Added.by.KWShin.2024.03.29.
import bus from '@/utils/bus';
// FINISH::Added.by.KWShin.2024.03.29.
// BEGIN::Added.by.SHJ.2026.04.29.
import { api } from '@/api/common/instances';
// FINISH::Added.by.SHJ.2026.04.29.
import lineChartable from './lineChartable';

export default {
  mixins: [lineChartable],
  data() {
    return {
      motletOptions: {
        // id: 'detailview/abap/user/LogonUser',
        id: 'dv/abap/user/user',
        title: 'dv.title.user',
        monitor: { monitorCode: 'C_ABAP_LOGON_USER', eventCode: 'LOGON_USER', points: 120, valueField: 'idCount' },
        settings: { chart: { use: true } },
        xAxisPoints: {
          use: true,
          divider: true,
          ready: false,
          value: 120,
          default: 120,
        },
      },
      socketData: [],
    };
  },
  watch: {
    sstmId: {
      handler() {
        // BEGIN::Modified.by.KWShin.2024.02.29.
        // this.sendMessage();
        if (this.activeIncrement && this.motletOptions.xAxisPoints.ready) this.sendMessage();
        // FINISH::Modified.by.KWShin.2024.02.29.
      },
    },
    activeIncrement: {
      immediate: true,
      handler(value) {
        // BEGIN::Modified.by.KWShin.2024.02.29.
        // if (value) this.sendMessage();
        if (value && this.motletOptions.xAxisPoints.ready) this.sendMessage();
        // FINISH::Modified.by.KWShin.2024.02.29.
      },
    },
    // BEGIN::Added.by.SHJ.2026.05.13. 언어 변경 시 헤더 타이틀 재합성
    '$i18n.locale'() {
      const field = this.motletOptions.settings.chart.field;
      if (field && field.code) this.chartFieldChanged(field.code);
    },
    // FINISH::Added.by.SHJ.2026.05.13.
  },
  methods: {
    //BEGIN::modified.by.KWShin.2024.03.23.
    /*
    wsBufferedDataHandler(key, responses) {
      const [response] = responses;
      const bound = response.length < this.monitor.points ? response.length : this.monitor.points;
      const data = response.slice(response.length - bound).map(item => {
        return this.dataHandler(item.data, item.ctime, item.empty);
      });
      this.socketData.push({
        id: key.instId,
        data,
      });
      if (this.socketData.length == this.descendants.length) {
        this.data = merge([], this.socketData);
        this.socketData = [];
        this.prepend(['idCount', 'sessionCount']);
      }
    },
    wsDataHandler(key, response, ctime, empty) {
      const data = this.dataHandler(response, ctime, empty);
      this.socketData.push({
        id: key.instId,
        data,
      });
      if (this.socketData.length == this.descendants.length) {
        this.descendants.forEach(() => {
          const socketData = this.socketData[0];
          const target = this.data.find(d => d.id == socketData.id);
          if (target) {
            target.data.push(socketData.data);
            this.socketData.splice(0, 1);
          }
        });
        if (!this.socketData.length) this.prepop();
      }
    },
    dataHandler(response, ctime, empty) {
      if (isEmpty(response)) response = [{ stime: ctime }];
      const data = {
        ctime: parseInt(ctime) - (parseInt(ctime) % this.monitor.cycle), // db 데이터 간격 기준으로 실시간 데이터를 근사값으로 보정,
        stime: parseInt(response[0].stime),
        idCount: '',
        sessionCount: '',
      };
      if (!empty) {
        data.idCount = 0;
        data.sessionCount = 0;
        response.forEach(r => {
          data.sessionCount += parseInt(r.extmodi);
          if (!!r.type && r.type != 'RFC') data.idCount++;
        });
      }
      return data;
    },
    sendMessage() {
      this.$websocket.realtime.subscribe({
        requests: this.descendants.map(descendant => ({
          key: { name: 'rawLogonUser', sstmId: descendant.systemId, instId: descendant.id },
          fields: ['stime', 'extmodi', 'type'],
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        })),
      });
    },
    */
    wsBufferedDataHandler(key, responses) {
      const [response] = responses;
      const data = response.map(item => {
        return this.dataHandler(item.data, item.ctime);
      });
      this.socketData.push({
        id: key.instId,
        data,
      });
      if (this.socketData.length == this.descendants.length) {
        this.data = merge([], this.socketData);
        this.socketData = [];
        // BEGIN::Added.by.SHJ.2026.04.29.
        // WS 버퍼가 monitor.points 만큼 채워지지 않은 경우, 앞쪽 빈 슬롯을 만들어 두고
        // backfillFromDb()에서 DB 데이터로 채울 수 있도록 한다.
        this.prepend(['idCount', 'sessionCount']);
        // FINISH::Added.by.SHJ.2026.04.29.
        /*
         * Added.by.KWShin.2024.03.29.
         * 차트에서 MarkLine이 그려질 때 'change:timestamp' 이벤트가 발생되면,
         * 부모 컴포넌트에서 이 이벤트를 받아 그리드와 다이어그램에 timestamp 변경을 통지하는데,
         * markLine은 화면이 시작된 이후 최초의 수집주기가 지나야 그려져서
         * 화면이 진입한 후 최초의 수집주기가 지나기 전까지는 그리드에 데이터 표시도 안되고
         * 다이어그램이 그려지지도 않는다.
         * 따라서, 이 시점에서 'change:timestamp' 이벤트를 발생시켜 주어서 화면 진입 후 즉각적으로
         * 그리드와 다이어그램이 정상적으로 표시될 수 있도록 한다.
         */
        // 데이터 수집이 안되고 있는 시스템이 있을 수 있으므로 this.data의 유무를 체크해야 한다.
        if (this.data && this.data.length > 0) {
          bus.$emit(`change:timestamp-${this.storeName}`, {
            eventCode: this.motletOptions.monitor.eventCode,
            timestamp: this.data[this.data.length - 1].ctime,
          });
        }
        // BEGIN::Added.by.SHJ.2026.04.29.
        // WS 버퍼가 차트 X축 개수(monitor.points)만큼 채우지 못한 경우 앞쪽 빈 구간을 DB에서 보충한다.
        this.backfillFromDb();
        // FINISH::Added.by.SHJ.2026.04.29.
      }
    },
    wsDataHandler(key, response, ctime) {
      const data = this.dataHandler(response, ctime);
      this.socketData.push({
        id: key.instId,
        data,
      });
      if (this.socketData.length == this.descendants.length) {
        this.descendants.forEach(() => {
          const socketData = this.socketData[0];
          const target = this.data.find(d => d.id == socketData.id);
          if (target) {
            target.data.push(socketData.data);
            this.socketData.splice(0, 1);
          }
        });
        if (!this.socketData.length) this.prepop();
      }
    },
    dataHandler(response, ctime) {
      const data = {
        ctime: parseInt(ctime) - (parseInt(ctime) % this.monitor.cycle), // db 데이터 간격 기준으로 실시간 데이터를 근사값으로 보정,
        stime: parseInt(response[0].stime),
        idCount: 0,
        sessionCount: 0,
      };

      data.idCount = 0;
      data.sessionCount = 0;
      response.forEach(rspn => {
        data.idCount += parseInt(rspn.idCnt);
        data.sessionCount += parseInt(rspn.sssnCnt);
      });

      return data;
    },
    // BEGIN::Added.by.SHJ.2026.04.29.
    /**
     * WS 버퍼가 monitor.points 만큼 채워지지 않았을 때 DB(cnt_logon_user)에서 부족한 앞 구간을 조회해
     * 이미 비어있는 슬롯(idCount===undefined)에만 값을 주입한다. 실제 WS 데이터는 덮어쓰지 않는다.
     */
    async backfillFromDb() {
      if (!this.data || this.data.length === 0) return;
      const firstInst = this.data[0].data;
      if (!firstInst || firstInst.length === 0) return;
      const realPoints = firstInst.filter(d => d.idCount !== undefined && d.idCount !== '');
      if (realPoints.length === firstInst.length) return;
      const beginYmdhms = firstInst[0].ctime;
      const endYmdhms = realPoints.length > 0 ? realPoints[0].ctime - this.monitor.cycle : firstInst[firstInst.length - 1].ctime;
      if (endYmdhms < beginYmdhms) return;
      const params = {
        beginYmdhms,
        endYmdhms,
        sstmId: this.sstmId,
        motletCode: this.monitor.monitorCode,
      };
      try {
        const { data: results } = await api.get('/motlet-data/chart', { params });
        if (!results || results.length === 0) return;
        results.forEach(result => {
          const inst = this.data.find(d => d.id === result.key.instId);
          if (!inst) return;
          result.data.forEach(db => {
            const dbCtime = parseInt(db.ctime);
            const slot = inst.data.find(p => p.ctime === dbCtime);
            if (slot && (slot.idCount === undefined || slot.idCount === '')) {
              slot.idCount = parseInt(db.idCount);
              slot.sessionCount = parseInt(db.sessionCount);
              if (db.stime) slot.stime = parseInt(db.stime);
            }
          });
        });
      } catch (e) {
        // DB 조회 실패 시 차트는 WS 실시간 수신으로 점진적으로 채워지므로 무시한다.
        console.warn('[LogonUser] backfillFromDb failed', e);
      }
    },
    // FINISH::Added.by.SHJ.2026.04.29.
    /**
     * Added.by.KWShin.20204.03.29.
     * 부모가 X축 길이 설정값을 가져온 뒤 호출해준다.
     * Motlet 메뉴에서 X축 길이 설정이 변경되었을 때에도
     * 편의상 (로직이 동일하므로) 자기 스스로 호출한다.
     */
    xPointsChanged(xPoints) {
      this.motletOptions.xAxisPoints.ready = true;
      this.motletOptions.xAxisPoints.value = xPoints;
      this.motletOptions.monitor.points = xPoints;
      // setXAxisPoints()는 lineChartable.js에 mixins된 motletable.js에 선언된 메소드로 store를 변경시켜준다.
      this.setXAxisPoints(xPoints);
      this.setMonitor(this.motletOptions.monitor);
      /*
       * DB 설정에서 읽어온 xPoints 값을 부모가 전달해주기 전까지는 데이터 구독이 방지되어 있는 상태이므로,
       * 부모에게서 통지가 왔을 때 데이터 구독을 시작한다.
       */
      if (this.activeIncrement) this.sendMessage();
    },
    /**
     * Added.by.KWShin.20204.03.11.
     * 부모가 차트 필드 항목 설정값을 가져온 뒤 호출해준다.
     * Motlet 메뉴에서 차트 필드 설정이 변경되었을 때에도
     * 편의상 (로직이 동일하므로) 자기 스스로 호출한다.
     */
    chartFieldChanged(code) {
      this.motletOptions.settings.chart.field = this.chartFields.find(f => f.code == code);
      // setChartField()는 lineChartable.js에 mixins된 motletable.js에 선언된 메소드로 store를 변경시켜준다.
      // 설정값은 API로 DB를 갔다오므로 지연이 발생하고
      // store는 MotletNeo.vue가 생성되는 시점에 등록되므로
      // 부모가 설정 변경을 알려줄 때 다시 한번 store 값을 변경해준다.
      this.setChartField(code);
      // 차트 항목이 변경되었으므로 서브타이틀을 바꾸어 준다.2026.06.16.
      this.motletOptions.subTitle = `(${this.motletOptions.settings.chart.field.text})`;
    },
    sendMessage() {
      this.$websocket.realtime.send({
        requests: this.descendants.map(descendant => ({
          key: { name: 'cntLogonUserType', sstmId: descendant.systemId, instId: descendant.id },
          fields: ['stime', 'idCnt', 'sssnCnt'],
          // BEGIN::Added.by.KWShin.2024.03.06.
          bufferSize: this.monitor.points,
          // FINISH::Added.by.KWShin.2024.03.06.
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        })),
      });
    },
    //FINISH::modified.by.KWShin.2024.03.23.
  },
  created() {
    // BEGIN::Added.by.KWShin.2024.03.29.
    bus.$on(`update:xAxisPoints-${this.motletOptions.id}`, xAxisPoints => {
      /*
       * 실시간인 상태에서 X축 표시범위를 변경하게 되면 차트를 동기화하기가 너무 어렵다.
       * 설정이 변하는 시점에서는 실시간 상태를 꺼준다.
       */
      bus.$emit(`update:activeIncrement`, false);
      this.xPointsChanged(xAxisPoints);
    });
    bus.$on(`update:chartFieldCode-${this.motletOptions.id}`, chartFieldCode => {
      this.chartFieldChanged(chartFieldCode);
    });
    // FINISH::Added.by.KWShin.2024.03.29.
  },
  destroyed() {
    // BEGIN::Added.by.KWShin.2024.03.29.
    bus.$off(`update:xAxisPoints-${this.motletOptions.id}`);
    bus.$off(`update:chartFieldCode-${this.motletOptions.id}`);
    // FINISH::Added.by.KWShin.2024.03.29.
  },
};
</script>
